import TypeIt from "typeit";

const one = (element) => {
    new TypeIt(element, {
        cursorChar: element.dataset.typedCursor || "_",
        speed: parseInt(element.dataset.typedSpeed || 50),
        startDelay: parseInt(element.dataset.typedDelay || 0),
    })
        .type("L'Inteligenza Artificile", { delay: 100 })
        .move(-17, { delay: 100 })
        .type("l", { delay: 400 })
        .move(null, { to: "END", instant: true, delay: 300 })
        .move(-2, { delay: 200 })
        .type("a", { delay: 225 })
        .pause(200)
        .move(null, { to: "END" })
        .type(" che Potnzia il Tuo Busines")
        .move(-19, { delay: 150 })
        .type("e")
        .move(null, { to: "END" })
        .type("s", { delay: 400 })
        .type(".")
        .go();
}

document.addEventListener("DOMContentLoaded", function () {

    const elements = document.querySelectorAll('[data-typed]');

    for (let element of elements) {

        element.innerHTML = '';

        if (!!element.dataset.typedVariant && element.dataset.typedMode === 'correct') {

            switch (element.dataset.typedVariant) {
                case '1':
                    one(element);
                    break;
            }

        } else {
            new TypeIt(element, {
                strings: element.dataset.typed,
                cursorChar: element.dataset.typedCursor || "_",
                speed: parseInt(element.dataset.typedSpeed || 50),
                startDelay: parseInt(element.dataset.typedDelay || 0),
            }).go();
        }
    }

});
